export default {
    BREAKERS: 'breakers',
    FUSES: 'fuses',
    UNKNOWN: 'unknown',
};
